export default [
  {
    header: 'Discharge',
    icon: 'GridIcon',
    route: 'discharge',
    title: 'Discharge'
  },
]
